import axios from '|/helpers/axios';
import { SLATE_ACCESSORIES_ENDPOINTS } from './endpoints';
import { AccessoriesResponse } from './types';

export const getCustomerAccessories = (customerId: string, abortSignal: AbortSignal) =>
  axios
    .get<AccessoriesResponse>(`${SLATE_ACCESSORIES_ENDPOINTS.ACCESSORIES}/${customerId}`, {
      signal: abortSignal
    })
    .then(res => res.data);

export const completeCustomerAccessories = (
  customerId: string,
  abortSignal: AbortSignal
): Promise<void> =>
  axios
    .post<never>(`${SLATE_ACCESSORIES_ENDPOINTS.ACCESSORIES}/${customerId}/complete`, undefined, {
      signal: abortSignal
    })
    .then(() => undefined);
